import { createAction, props } from '@ngrx/store';

export const setGlobalFontSize = createAction('[Settings] Set Global Font Size', props<{ size: string }>());

export const SettingsActionTypes: string[] = [setGlobalFontSize.type];
